import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PlatinumPageRoutingModule } from './platinum-routing.module';

import { MatSelectModule } from '@angular/material/select';

import { PlatinumPage } from './platinum.page';
import { UpgradeFormModule } from '../upgrade-form/upgrade-form.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MatSelectModule,
    UpgradeFormModule,
    PlatinumPageRoutingModule
  ],
  declarations: [PlatinumPage]
})
export class PlatinumPageModule {}
